import React from 'react';
import ShareRedirect from './share-redirect';

const ShareGroup = () => <ShareRedirect shareType="group" />;

export default ShareGroup;
